// @flow

import type {ApplicationState} from '../../types'
import type {MapState} from '../types'

export function isReady(appState: ApplicationState): boolean {
  return _isReady(appState.map) 
}

function _isReady(state: MapState): boolean{
  return state.isReady
}

isReady.internal = _isReady
